import type { Action } from 'redux';
import { format, endOfDay, subDays } from 'date-fns';
import dash_api from '../../../../main/support/dash_api';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const FetchCampaignOptions = new ReduxAsyncAction<'FETCH_CAMPAIGN_OPTIONS', void, any>('FETCH_CAMPAIGN_OPTIONS');

FetchCampaignOptions.registerRequest(async (): Promise<any> => {
  const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
  const startTimestamp = format(endOfDay(new Date()), DATE_FORMAT);
  const endTimestamp = format(
    subDays(new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate())), 90),
    DATE_FORMAT
  );

  try {
    const { data } = await dash_api.post('/v1/marketing/topcampaign', {
      start_time: startTimestamp,
      end_time: endTimestamp,
    });
    return data;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch campaign options.', 'error');
    throw error;
  }
});

export const FETCH_CAMPAIGN_OPTIONS = FetchCampaignOptions.actionNamespaceConstants;
export const fetchCampaignOptions = FetchCampaignOptions.request;

export type FetchCampaignOptionsResponseAction = Action<typeof FETCH_CAMPAIGN_OPTIONS.response> & {
  data: any;
};
